import Vue from 'vue';
import Router from 'vue-router';
import {routers} from './router';
import {wxShare} from '@/utils/wechat-util';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  base: '/m',
  routes: routers,
});

/** 路由到下一个页面前执行的钩子 */
// router.beforeEach(({meta, name, path}, from, next) => {
//   if(name === 'hotel-payment'){
//     const origin = window.location.origin;
//     const pathName = window.location.pathname;
//
//     window.location.href = `${origin}${pathName}`;
//
//     return ;
//   }
//   next();
// });

/** 路由到下一个页面后执行的钩子 */
router.afterEach((to) => {
  if(to.name !== 'hotel-detail'){
    document.documentElement.scrollTop = 0;
    // document.body.scrollTop = 0;

    setTimeout(() => {
      // 微信分享
      wxShare();
    }, 200);
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js